export class Task {
    taskId: string;
    taskStatusCode: string;
    taskTypeCode: string;
    //dateString: string;
    dateRequested: Date;
    applicationName: string;
    requestedBy: string;
    actionedByRoleCode: string;
    subject: string;
    actionUrl: string;
    extOrganisationId: string;
    organisationName: string;
}




// WEBPACK FOOTER //
// ./src/app/models/task.ts